import React, { useState } from 'react';
import { Text } from './Text';
import { TextButton, ImageButton } from './Button';
import { Image } from './Image';
import { CardContainer, FlexColumn, Flex } from './Container';
import ModalClose from '../../Images/promo-close.svg'
import Aion from '../../Images/aion-promo-logo.png'

const FullScreenModal = ({ text, name, imgSrc, onClick, content, onClose }) => {
    const [isModalVisible, setIsModalVisible] = useState(true);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <FlexColumn
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                margin: 0,
                padding: 0,
                zIndex: 10001, // Ensure it appears on top
                transform: 'none', // Override any transformation
                background: '#F6F6F6',
            }}
            fullWidth
            fullHeight
        >
            {false && <Flex end style={{ padding: '16px 16px 0 0' }}><ImageButton src={ModalClose} onClick={onClose} /></Flex>}
            {content}
        </FlexColumn>
    );
};

export default FullScreenModal;
